<template>
  <div class="form-container narrow">
    <div class="form-header">
      <h2>Email Verification</h2>
    </div>
    <div v-if="loading" class="verify-message">
      <h2>Verifying your email...</h2>
      <div class="spinner"></div>
    </div>
    <div v-else-if="error" class="verify-message">
      <div class="error-message">
        Verification failed:<br>
        {{ error }}
      </div>
      <router-link to="/users/me/edit" class="link">Send a new verification email</router-link>
    </div>
    <div v-else-if="success" class="verify-message">
      <div class="success-message">
        Verification successful!<br>
        You can now close this window.
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { verifyEmail, updateUserInfo } from '@/scripts/services/authService';

const route = useRoute();
const error = ref('');
const success = ref(false);
const loading = ref(true);

onMounted(async () => {
  error.value = '';
  loading.value = true;
  const user_id = route.params.user_id;
  const token = route.params.token;
  const result = await verifyEmail(user_id, token);
  success.value = (result === true);
  if (success.value) {
    await updateUserInfo();
  } else {
    error.value = result;
  }
  loading.value = false;
});
</script>

<style scoped>
@import '@/styles/shared-form.css';

.spinner {
  width: 40px;
  height: 40px;
  margin: 20px auto;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #d68813;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
